/**
 * List of menu items for Top Menu
 */
export const TopMenuLinks = [
	{
		path: "/egift",
		className: "link link-egift",
		exact: true,
		title: "header.topMenu._starbucksEgift",
	},
	{
		path: "/landing#benefits",
		className: "link link-benefits",
		exact: true,
		title: "header.topMenu._benefits",
	},
	{
		path: "/landing#mobile-app",
		className: "link link-mobile-app",
		exact: true,
		title: "header.topMenu._mobile_app",
	},
	{
		path: "/landing#view-card-designs",
		className: "link link-view-card-designs",
		exact: true,
		title: "header.topMenu._view_card_designs",
	},
	// {
	// 	path: "/landing#faqs",
	// 	className: "link link-faqs",
	// 	exact: true,
	// 	title: "header.topMenu._faqs",
	// },
]

/**
 * List of menu items for Sidebar Menu
 */
export const SidebarMenuLinks = [
	{
		path: "/account",
		className: "link",
		exact: true,
		title: "sidebar.navigation._account",
	},
	{
		path: "/rewards",
		className: "link",
		title: "sidebar.navigation._rewards",
	},
	{
		path: "/profile",
		className: "link",
		title: "sidebar.navigation._profile",
	},
	{
		path: "/cards",
		className: "link",
		title: "sidebar.navigation._cards",
	},
	{
		path: "/e-gift",
		className: "link",
		title: "sidebar.navigation._egift",
	},
	{
		path: "/transactions",
		className: "link",
		title: "sidebar.navigation._transactions",
	},
	{
		path: "/contact-us",
		className: "link",
		title: "sidebar.navigation._contactUs",
	},
	{
		path: "/logout",
		className: "link",
		title: "sidebar.navigation._logout",
	},
	/*{
		path: "/unregister",
		className: "link link-primary fw-bolder",
		title: "sidebar.navigation._unregister",
	},*/
]

/**
 * List of menu items for Footer menu
 */
export const FooterMenuLinks = [
	{
		title: "ABOUT US",
		titlePath: "http://en.starbucks.vn/about-us/",
		items: [
			{
				path: "http://en.starbucks.vn/about-us/our-heritage/",
				className: "link",
				exact: true,
				title: "Our Heritage",
			},
			{
				path: "http://en.starbucks.vn/about-us/company-information/",
				className: "link",
				exact: true,
				title: "Our Company",
			},
			{
				path: "http://en.starbucks.vn/about-us/career-center/",
				className: "link",
				exact: true,
				title: "Career Center",
			},
			{
				path: "https://news.starbucks.com/",
				className: "link",
				exact: true,
				title: "Newsroom",
			},
		],
	},
	{
		title: "CUSTOMER SERVICE",
		titlePath: "http://en.starbucks.vn/customer-service/",
		items: [
			{
				path: "http://en.starbucks.vn/customer-service/frequently-asked-questions/",
				className: "link",
				exact: true,
				title: "Frequently Asked Questions",
			},
		],
	},
	{
		title: "QUICK LINKS",
		titlePath: "",
		items: [
			{
				path: "http://en.starbucks.vn/store-locator/search",
				className: "link",
				exact: true,
				title: "Store Locator",
			},
			{
				path: "https://www.starbucks.com/reference/partners",
				className: "link",
				exact: true,
				title: "For Partners",
			},
		],
	},
]

export const viFooterMenuLinks = [
	{
		title: "VỀ CHÚNG TÔI",
		titlePath: "http://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/",
		items: [
			{
				path: "http://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/di-s%E1%BA%A3n/",
				className: "link",
				exact: true,
				title: "Di sản",
			},
			{
				path: "http://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C3%B4ng-ty/",
				className: "link",
				exact: true,
				title: "Công ty",
			},
			{
				path: "http://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C6%A1-h%E1%BB%99i-ngh%E1%BB%81-nghi%E1%BB%87p/",
				className: "link",
				exact: true,
				title: "Cơ hội nghề nghiệp",
			},
			{
				path: "/",
				className: "link",
				exact: true,
				title: "",
			},
		],
	},
	{
		title: "DỊCH VỤ KHÁCH HÀNG",
		titlePath:
			"http://www.starbucks.vn/d%E1%BB%8Bch-v%E1%BB%A5-kh%C3%A1ch-h%C3%A0ng/",
		items: [
			{
				path: "http://www.starbucks.vn/d%E1%BB%8Bch-v%E1%BB%A5-kh%C3%A1ch-h%C3%A0ng/c%C3%A2u-h%E1%BB%8Fi-th%C6%B0%E1%BB%9Dng-g%E1%BA%B7p/",
				className: "link",
				exact: true,
				title: "Câu hỏi Thường Gặp",
			},
		],
	},
	{
		title: "LIÊN KẾT NHANH",
		titlePath: "",
		items: [
			{
				path: "http://www.starbucks.vn/b%E1%BB%99-%C4%91%E1%BB%8Bnh-v%E1%BB%8B-c%E1%BB%ADa-h%C3%A0ng/search",
				className: "link",
				exact: true,
				title: "Bộ định vị Cửa hàng",
			},
			{
				path: "https://www.starbucks.com/reference/partners",
				className: "link",
				exact: true,
				title: "Dành cho Đối tác",
			},
		],
	},
]
